import { render, staticRenderFns } from "./matchPage.vue?vue&type=template&id=5813e93c&scoped=true&"
import script from "./matchPage.vue?vue&type=script&lang=js&"
export * from "./matchPage.vue?vue&type=script&lang=js&"
import style0 from "./matchPage.vue?vue&type=style&index=0&id=5813e93c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5813e93c",
  null
  
)

export default component.exports